module.exports = __webpack_public_path__ + "img/btn.0646e7b2.png";